import {
  TransactionSource,
  SourceComponent,
  EntryMethod,
  CheckType,
  AccountType,
} from './payment.model';

export class TransactionLogs {
  public Label: string;
  public SurchargeAmount: number = 0;
  public SurchargePercentage: number = 0;
}

export class ACHPayment {
  public AccountNumber: string;
  public RoutingNumber: string;
  public CheckType: CheckType;
  public SecCode: string;
  public AccountType: AccountType;
  public EntryMethod: EntryMethod;
  public CheckHolderName: string;
  public BankName: string;
  public StreetAddress1: string;
  public City: string;
  public State: string;
  public PostalCode: string;
  public Country: string;
  public Amount: number;
  public Currency: string;
  public InvoiceNumber: string;
  public OrderId: string;
  public TerminalId: string;
  public LocationId: number;
  public TransactionId: string;
  public UserId: string;
  public TransactionSource: TransactionSource | string;
  public CustomerId: string;
  public SourceComponent: SourceComponent;
  public IsPartialPayment: boolean;
  public SecretApiKey: string;
  public MID: string;
  public Transaction: any;
  public ReceiptNumber: string;
  public Email: string;
  public TransactionLogs?: [TransactionLogs];
  public Notes?: string;

  public ACHPayment() {
    this.TransactionSource = TransactionSource.Merchant;
    this.Amount = 0;
    this.Currency = 'USD';
    this.SecCode = 'WEB';
    this.AccountType = AccountType.CHECKING;
  }
}

export class NewACHPAyment {
  public amount: number;
  public authAmount: number;
  public currency: string;
  public gratuity: number;
  public requestMultiUseToken: boolean;
  public locationId: number | string;
  public invoiceNumber: string;
  public transactionId: string;
  public terminalId: string;
  public customerId: number;
  public TransactionSource: string;
}

export class ACHOnFilePayment {
  public customerId: number;
  public locationId: number;
  public amount: number;
  public currency: string;
  public paymentIdentifier: string;
  public terminalId: string;
  public transactionSource: string;
  public isPartialPayment: boolean;
  public sourceComponent: string;
  public userId: number;
  public invoiceNumber?: string;
  public TransactionLogs?: [TransactionLogs];
  public Notes?: string;
}
